export const IzimiLogo = () => (
  <svg width='64' height='64' viewBox='0 0 64 64' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <rect width='64' height='64' rx='12' fill='url(#paint0_linear_9265_2512)' />
    <path
      d='M36.1079 20.8028C36.1085 21.7536 35.8271 22.6832 35.2993 23.4741C34.7714 24.2649 34.0209 24.8814 33.1426 25.2455C32.2643 25.6096 31.2977 25.7051 30.3651 25.5197C29.4326 25.3344 28.5759 24.8766 27.9036 24.2043C27.2313 23.532 26.7735 22.6754 26.5882 21.7428C26.4028 20.8102 26.4983 19.8437 26.8624 18.9653C27.2265 18.087 27.843 17.3365 28.6339 16.8086C29.4247 16.2808 30.3543 15.9994 31.3051 16C32.5786 16.0008 33.7998 16.5071 34.7003 17.4076C35.6008 18.3082 36.1071 19.5293 36.1079 20.8028Z'
      fill='#E58F38'
    />
    <path
      d='M31.2917 34.041L34.9309 37.4772L31.4604 41.0386C31.4428 41.0606 31.4202 41.0784 31.3944 41.0906C31.3686 41.1029 31.3402 41.1092 31.3115 41.1092C31.2828 41.1092 31.2545 41.1029 31.2287 41.0906C31.2029 41.0784 31.1803 41.0606 31.1626 41.0386L27.798 37.2719L31.2917 34.041Z'
      fill='#C95C2B'
    />
    <path
      d='M25.5085 34.7371L25.482 43.3293C25.4811 43.5066 25.4079 43.6763 25.2783 43.8014C25.1487 43.9265 24.9734 43.9967 24.7906 43.9967H20.1885C20.0057 43.9967 19.8303 43.9265 19.7008 43.8014C19.5712 43.6763 19.4979 43.5066 19.4971 43.3293V28.6636L25.5085 34.7371Z'
      fill='#C95C2B'
    />
    <path
      d='M43.4369 28.6636V43.3261C43.4369 43.4144 43.4189 43.5019 43.384 43.5835C43.349 43.665 43.2978 43.7391 43.2332 43.8014C43.1687 43.8637 43.092 43.913 43.0078 43.9466C42.9235 43.9801 42.8332 43.9971 42.7422 43.9967H38.2526C38.0695 43.9958 37.8941 43.9249 37.7646 43.7993C37.6352 43.6738 37.562 43.5037 37.5612 43.3261V34.766L43.4369 28.6636Z'
      fill='#C95C2B'
    />
    <path
      d='M19.4905 22.4231V28.6635L25.5085 34.7371L31.1593 41.0417L27.7979 37.2717L31.3049 34.0409L19.7849 22.391C19.6559 22.2306 19.5236 22.1985 19.4905 22.4231Z'
      fill='#E58F38'
    />
    <path
      d='M43.1391 22.391L31.2916 34.0409L34.9309 37.4771L37.5776 34.766L43.4435 28.6699V22.4231C43.4104 22.1985 43.2781 22.2306 43.1457 22.391'
      fill='#E58F38'
    />
    <defs>
      <linearGradient
        id='paint0_linear_9265_2512'
        x1='32'
        y1='0'
        x2='32'
        y2='64'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0.179733' stopColor='#F7E1CB' />
        <stop offset='1' stopColor='#EAB177' />
      </linearGradient>
    </defs>
  </svg>
);
